/**
 * Declaring the redux reducers and default state
 * for snb candidate filters
 *
 * @author John Lukose <john.lukose@quikr.com>
 */

import EVENTS from '../../constants/events';
import { setFiltersFromUrl, setFilterData, getUrlFromFilters, fireEventForFilter } from '../../utils/Filter';

export let defaultFilters = {
	url: '',
	popupOpened: 0,
	loaded: 0,
	selectedFilters: [],
	isMyNorthEastCityFilter: false,
	showNorthEastCityFilter: false,
	filters: {
		role: {
			name: 'role',
			type: 'search',
			displayName: 'Roles',
			displayInFilter: 0,
			multiValued: 0,
			selected: [],
			options: [],
			subOptionsKey: 'subrole',
			subrole: {
				name: 'subrole',
				type: 'search',
				displayName: 'Sub Roles',
				displayInFilter: 0,
				multiValued: 1,
				selected: []
			}
		},
		city: {
			name: 'city',
			type: 'search',
			displayName: 'City',
			displayInFilter: 0,
			multiValued: 0,
			selected: [],
			options: []
		},
		locality: {
			name: 'locality',
			type: 'search',
			displayName: 'Locality',
			displayInFilter: 0,
			multiValued: 1,
			selected: [],
			options: []
		},
		salary: {
			name: 'salary',
			type: 'checkbox',
			displayName: 'Salary',
			displayInFilter: 1,
			multiValued: 0,
			selected: [],
			options: [
				{ value: 5000, displayValue: '₹ 5,000 and above' },
				{ value: 6000, displayValue: '₹ 6,000 and above' },
				{ value: 7000, displayValue: '₹ 7,000 and above' },
				{ value: 8000, displayValue: '₹ 8,000 and above' },
				{ value: 9000, displayValue: '₹ 9,000 and above' },
				{ value: 10000, displayValue: '₹ 10,000 and above' },
				{ value: 15000, displayValue: '₹ 15,000 and above' },
				{ value: 20000, displayValue: '₹ 20,000 and above' },
				{ value: 25000, displayValue: '₹ 25,000 and above' },
				{ value: 30000, displayValue: '₹ 30,000 and above' },
				{ value: 35000, displayValue: '₹ 35,000 and above' },
				{ value: 40000, displayValue: '₹ 40,000 and above' },
				{ value: 45000, displayValue: '₹ 45,000 and above' },
				{ value: 50000, displayValue: '₹ 50,000 and above' },
				{ value: 60000, displayValue: '₹ 60,000 and above' },
				{ value: 70000, displayValue: '₹ 70,000 and above' },
				{ value: 80000, displayValue: '₹ 80,000 and above' },
				{ value: 90000, displayValue: '₹ 90,000 and above' },
				{ value: 100000, displayValue: '₹ 1 Lakh and above' },
				{ value: '', displayValue: '' }
			]
		},
		type: {
			name: 'type',
			type: 'checkbox',
			displayName: 'Job Type',
			multiValued: 1,
			displayInFilter: 1,
			selected: [],
			options: [
				{
					value: 'work-from-home',
					displayValue: 'Work From Home',
					display: 1
				},
				{
					value: 'part-time',
					displayValue: 'Part Time Jobs',
					display: 1
				},
				{
					value: 'full-time',
					displayValue: 'Full Time Jobs',
					display: 1
				},
				{
					value: 'internship',
					displayValue: 'Internships',
					display: 1
                },
                {
					value: 'abroad',
					displayValue: 'Work Abroad',
					display: 1
				}
			]
		},
		sort: {
			name: 'sort',
			displayName: 'Sort',
			displayInFilter: 0,
			multiValued: 0,
			sortPopupOpened: 0,
			selected: [
				'relevancy'
			],
			options: [
				{
					value: 'relevancy',
					displayValue: 'Popular'
				},
				{
					value: 'dt:DESC',
					displayValue: 'Recent'
				},
				{
					value: 'dt:ASC',
					displayValue: 'Oldest'
				}
			]
		},
		company: {
			name: 'company',
			displayName: 'Company',
			type: 'search',
			displayInFilter: 0,
			multiValued: 0,
			selected: [],
			options: []
		},
		keyword: {
			name: 'keyword',
			displayName: 'keyword',
			type: 'search',
			displayInFilter: 0,
			multiValued: 0,
			selected: [],
			options: []
		}
	}
};


const defaultFiltersObj = JSON.parse(JSON.stringify(defaultFilters));
const defaultFilterLoadState = setFiltersFromUrl(defaultFiltersObj);

const FilterReducer = (state = defaultFilterLoadState, actions) => {
	switch (actions.type) {
		case EVENTS.SNB_CONTAINER_EVENTS.SORT_FILTER_CLICKED:{
			state =  Object.assign({},state);
			state.filters.sort.sortPopupOpened = 1;
			break;
		}
		case EVENTS.SNB_CONTAINER_EVENTS.SORT_FILTER_CLOSED:{
			state =  Object.assign({},state);
			state.filters.sort.sortPopupOpened = 0;
			break;
		}
		case EVENTS.SNB_CONTAINER_EVENTS.SORT_FILTER_ITEM_CLICKED:{
			state =  Object.assign({},state);
			state.filters.sort.selected = [actions.payload.selectedFilter];
			state.filters.sort.sortPopupOpened = 0;
			state.url = getUrlFromFilters(state);
			break;
		}
		case EVENTS.SNB_CONTAINER_EVENTS.FILTER_OPEN:{
			state =  Object.assign({},state);
			state.popupOpened = 1;
			break;
		}
		case EVENTS.SNB_CONTAINER_EVENTS.FILTER_MOUNTED:{
			state =  Object.assign({},state);
			state = setFilterData(state, actions.payload.response);
			break;
		}
		case EVENTS.SNB_CONTAINER_EVENTS.FILTER_CLOSE:{
			state =  Object.assign({},state);
			state.popupOpened = 0;
			break;
		}
		case EVENTS.SNB_CONTAINER_EVENTS.FILTER_PREPARE:{
			state =  Object.assign({},state);
			state.url = getUrlFromFilters(state);
			if(typeof dataLayer != 'undefined'){
				dataLayer.push({"event": "filters_select",
				 "platform": "pwa"});
			}
			break;
		}
		case EVENTS.SNB_CONTAINER_EVENTS.FILTER_APPLY:{
			state =  Object.assign({},state);
			fireEventForFilter(state);
			state.popupOpened = 0;
			break;
		}
		case EVENTS.SNB_CONTAINER_EVENTS.FILTER_RESET:{
			Object.keys(state.filters).forEach((key) => {
				if ('sort' !== key && 'city' !== key )
					state.filters[key].selected = [];

				if (state.filters[key].subOptionsKey) {
					state.filters[key][state.filters[key].subOptionsKey].selected = [];
				}
			});
			state =  Object.assign({},state);
			state.url = getUrlFromFilters(state);
			state.popupOpened = 0;
			break;
	}
		case EVENTS.SNB_CONTAINER_EVENTS.FILTER_ITEM_CLICKED:{
			if (actions.payload.innerKey ){
				let index = state.filters[actions.payload.key][actions.payload.innerKey].selected.indexOf(actions.payload.innerValue);
				if (index === -1) {
					if (actions.payload.isInnerMultiValued)
						state.filters[actions.payload.key][actions.payload.innerKey].selected.push(actions.payload.innerValue);
					else
						state.filters[actions.payload.key][actions.payload.innerKey].selected = [actions.payload.innerValue];
				}
				else {
					state.filters[actions.payload.key][actions.payload.innerKey].selected.splice(index, 1);
				}
				state =  Object.assign({},state);
				break;
			}
			else {
				let index = state.filters[actions.payload.key].selected.indexOf(actions.payload.value);
				if (index === -1) {
					if (actions.payload.multiValued)
						state.filters[actions.payload.key].selected.push(actions.payload.value);
					else {
						state.filters[actions.payload.key].selected = [actions.payload.value];
						let innerKey = state.filters[actions.payload.key].subOptionsKey;
						if (state.filters[actions.payload.key][innerKey]) {
							state.filters[actions.payload.key][innerKey].selected = [];
						}
					}
				}
				else {
					if (state.filters[actions.payload.key].subOptionsKey) {
						let innerKey = state.filters[actions.payload.key].subOptionsKey;
						if (state.filters[actions.payload.key][innerKey]) {
							state.filters[actions.payload.key][innerKey].selected = [];
						}
					}
					state.filters[actions.payload.key].selected.splice(index, 1);
				}

				state =  Object.assign({},state);
				break;
			}
		}
		case EVENTS.SNB_CONTAINER_EVENTS.UPDATE_FILTER_STATE: {
			state = Object.assign(state, actions.payload);
			break;
		}
		case EVENTS.SNB_CONTAINER_EVENTS.NORTHEAST_MY_CITY: {
			state.isMyNorthEastCityFilter = actions.payload.isMyNorthEastCityFilter;
			state.selectedFilters["isMyNorthEastCityFilter"] = state.isMyNorthEastCityFilter;
			state = Object.assign({},state);
			break;
		}
		case EVENTS.SNB_CONTAINER_EVENTS.SHOW_NORTHEAST_CITY_FILTER: {
			state.showNorthEastCityFilter = actions.payload.showNorthEastCityFilter;
		
			state = Object.assign({}, state);
			break;
		}
		default:
			break ;
	}
	state = transformSelectedFilterValues(state);
	return state;
};

function transformSelectedFilterValues(state) {
	if(state && state.filters && state.filters.locality && state.filters.locality.selected){
		state.filters.locality.selected = state.filters.locality.selected.map(each => Number.isInteger(each) ? each : each.toLowerCase().split(' ').join("-"));
	}

	if(state && state.filters && state.filters.type && state.filters.type.selected){
		state.filters.type.selected = state.filters.type.selected.map(each => Number.isInteger(each) ? each : each.toLowerCase().split(' ').join("-"));
	}

	if(state && state.filters && state.filters.role && state.filters.role.subrole && state.filters.role.subrole.selected){
		state.filters.role.subrole.selected = state.filters.role.subrole.selected.map(each => Number.isInteger(each) ? each : each.toLowerCase().split(' ').join("-"));
	}

	return state;
}

export default FilterReducer;



// WEBPACK FOOTER //
// ../q-jobs/src/reducers/SnbReducer/filter.js